module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer028"
    }
  }, [_c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Problem number one")]), _vm._v("—"), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("lacking natural controls")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" our human descendants will tend to overbreed until Stratos can no longer support their numbers")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Shall we then have come all this way to repeat the catastrophe of Earth?")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("One lesson we’ve learned")]), _vm._v("—"), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("any effort to limit population cannot rest on persuasion alone")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Times change")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Passions change")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" and even the highest flown moralizing eventually palls in the face of natural instinct")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We could do it genetically")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" limiting each woman to just two births")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" But variants who break the programming will outbreed all others")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" soon putting us back where we started")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Anyway")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" our descendants may at times")]), _vm._v(" need "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("rapid reproduction")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" We mustn’t limit them to a narrow way of life")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Our chief hope lies in finding ways of permanently tying self-interest to the common good")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The same holds for our other problem")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" which provoked this coalition to drop half-measures")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" leaving the Phylum’s bland compromisers behind")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" The problem which drove us to this faraway world")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" seeking a lasting solution")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The problem of sex")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "text-right-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—from "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The Apologia")]), _c('em', {
    staticClass: "italic",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(",")]), _vm._v(" by Lysos.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-000b2e6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504086356-6.vue
// module id = 90
// module chunks = 0